import http from 'utils/http';
import {
  getActivateBusinessAddonUrl,
  getBusinessAddonsUrl,
  getCancelBusinessAddonUrl,
  getReverseBusinessAddonCancellationUrl,
  getUpdateBusinessAddonQuantityUrl
} from './apiUrls';
import { ActivateBusinessAddonResponse, CancelBusinessAddonPayload, CancelBusinessAddonResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getBusinessAddons(params?: Record<string, unknown>): Promise<{
  data: import('./types').BusinessAddon[];
  meta?: MetaApiResponse;
}> {
  return http.get(getBusinessAddonsUrl(), params);
}

export interface ActivateBusinessAddonPayload {
  quantity?: number;
}

export function activateBusinessAddon(
  code: string,
  payload?: ActivateBusinessAddonPayload
): Promise<ActivateBusinessAddonResponse> {
  return http.post(getActivateBusinessAddonUrl(code), payload);
}

export function updateBusinessAddonQuantity(code: string, quantity: number): Promise<ActivateBusinessAddonResponse> {
  return http.patch(getUpdateBusinessAddonQuantityUrl(code), { quantity });
}

export function cancelBusinessAddon(
  code: string,
  payload: CancelBusinessAddonPayload
): Promise<CancelBusinessAddonResponse> {
  return http.post(getCancelBusinessAddonUrl(code), payload);
}

export function reverseBusinessAddonCancellation(code: string): Promise<CancelBusinessAddonResponse> {
  return http.post(getReverseBusinessAddonCancellationUrl(code));
}
